// src/belediye/services/mesajlasmaBridge.js
// F1 — "Olay → sohbet mesajı köprüsü" (tek mantık). Bir OLAY (bildirim, görev,
// başvuru) ile SOHBET arasındaki tek geçiş noktası. ChatDock bu olayı dinler ve
// sohbeti açar (sağ-alt panel). Böylece "sohbeti aç" davranışı TEK yerden akar —
// her yüzey aynı köprüyü çağırır (dağınık dispatch/navigate yok).

export const MESAJLASMA_OPEN_EVENT = "mesajlasma:open";
export const MESAJLASMA_TOGGLE_EVENT = "mesajlasma:toggle";
// FAZ-64 — "MESAJA ATLA". Görev detayındaki bir medya öğesinden (ya da "Sohbette
// onayla" yön levhasından) o medyanın geldiği MESAJA gitmek için. Sohbeti açan
// köprüyle aynı ailede: yüzeyler ChatThread'in içine uzanmaz, olay yollar.
export const MESAJLASMA_GOTO_EVENT = "mesajlasma:mesaja-git";

// Sohbeti sağ-alt panelde aç (conversationId ile). title opsiyonel (ilk kare
// başlığı — gerçek başlık poll'de gelir). SSR/güvenlik: window yoksa sessiz.
export const openChat = (conversationId, title = "") => {
  const id = Number(conversationId) || null;
  if (!id || typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(MESAJLASMA_OPEN_EVENT, { detail: { conversationId: id, title } })
  );
};

// Açık olan sohbeti belirli bir MESAJA kaydır + kısa süre vurgula.
// Sohbet o an ekranda değilse (mobil/tablet) çağıran önce sohbeti açar, sonra
// bunu yollar — köprü yalnız "git" der, açma işi çağıranındır.
export const gotoMessage = (conversationId, messageId) => {
  const cid = Number(conversationId) || null;
  const mid = Number(messageId) || null;
  if (!cid || !mid || typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(MESAJLASMA_GOTO_EVENT, { detail: { conversationId: cid, messageId: mid } })
  );
};

// FAZ-75 — "YENİ SOHBET/GÖREV" KÖPRÜSÜ.
// Kullanıcı (2026-07-30): "Görev Ata'da Yeni Görev'e tıklayınca sayfa içinde
// açılan form yapısını tamamen kaldır. Yeni göreve tıklayınca sohbet penceresi
// 'Yeni'ye tıklanmış ve seçilmiş şekilde ORTA boyda açılsın; kişiler görünsün,
// kişi seçilip 'Sohbeti Başlat' denince görev oluşsun."
//
// Görev vermenin TEK yüzeyi artık sohbet penceresi — ikinci bir oluşturma formu
// yok. Köprü yalnız "yeni sohbet panelini aç" der; kişiyi kim seçer, görevi kim
// oluşturur, hepsi pencerenin kendi işi (yüzeyler ChatDock'un içine uzanmaz).
export const MESAJLASMA_NEW_EVENT = "mesajlasma:yeni-sohbet";

export const openNewChat = (boy = "orta") => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(MESAJLASMA_NEW_EVENT, { detail: { boy } }));
};

// Paneli aç/kapat (navbar düğmesi gibi).
export const toggleChat = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(MESAJLASMA_TOGGLE_EVENT));
};
